(function () {
  if (window.__AG_LONG_BLOCKS_TIMELINE_INIT__) {
    return;
  }
  window.__AG_LONG_BLOCKS_TIMELINE_INIT__ = true;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initStep(step) {
    if (step.dataset.timelineReady === 'true') {
      return;
    }

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      step.classList.add('ag-long-blocks__tl--in-view');
      step.dataset.timelineReady = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('ag-long-blocks__tl--in-view');
          entry.target.dataset.timelineReady = 'true';
          observer.disconnect();
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.15
      }
    );

    observer.observe(step);
  }

  function initAll() {
    document.querySelectorAll('[data-timeline-step]').forEach(initStep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
